module.exports = __webpack_public_path__ + "static/lightbox-1f1505d84921f38990c554445a1508f7.jpg";